// extracted by mini-css-extract-plugin
module.exports = {"button":"EditSettingsPageView_button__1R3Jm"};